// Paleta pronta para etiquetas e automações: 12 tons distintos, bem espalhados
// pelo círculo cromático (sem quase-duplicatas) para as etiquetas ficarem fáceis
// de distinguir num relance nos cards. Inclui os acentos da marca (coral, roxo).
export const SWATCH_PALETTE = [
    '#E84C4E', // Coral (marca)
    '#F97316', // Laranja
    '#EAB308', // Amarelo
    '#16A34A', // Verde
    '#0D9488', // Teal
    '#0891B2', // Ciano
    '#2563EB', // Azul
    '#4D3DAB', // Roxo (marca)
    '#7C3AED', // Violeta
    '#DB2777', // Rosa
    '#64748B', // Cinza
    '#170C52', // Roxo profundo (marca)
];

export const DEFAULT_TAG_COLOR = '#4D3DAB';

// Decide se o texto sobre uma cor deve ser claro ou escuro (contraste/luminância).
export const tagTextColor = (hex) => {
    const value = (hex ?? '').replace('#', '');
    if (value.length < 6) return '#fff';
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#1d1d1b' : '#fff';
};
